// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"295":"7f5a7d23","435":"5f3aae95","466":"dda28b60","727":"09a2dea1","847":"310cc4f1","890":"e6bf3786","920":"de3b6d85"}[chunkId] + ".chunk.css";
};